import { Component, HostListener, Input } from '@angular/core';
import { BusinessObject } from '@libs/index';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { UrlUtils } from '@libs/index';
import { BreakpointService } from '@libs/index';
import { Product } from '@libs/index';
import { BusinessObjectUtils } from '@libs/index';
import { EnvUtils } from '../../../commons/utils/env.utils';

@Component({
  selector: 'app-salon-list-carousel',
  templateUrl: './salon-list-carousel.component.html',
  styleUrls: ['./salon-list-carousel.component.scss'],
})
export class SalonListCarouselComponent {
  private _businessObjects: BusinessObject[];
  @Input() set businessObjects(value: BusinessObject[]) {
    this._businessObjects = value;
    this.initSlidesPerView();
  }
  get businessObjects(): BusinessObject[] {
    return this._businessObjects;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.initSlidesPerView();
  }

  public slidePerView = 1;

  constructor(
    private breakpointService: BreakpointService,
    private navigationService: NavigationService
  ) {}

  public async navigateToSalonDetails(businessObject: BusinessObject) {
    if (businessObject?.urlName) {
      await this.navigationService.navigateToSalonDetails(
        businessObject.urlName
      );
    }
  }

  public getSalonPicture(salon: BusinessObject): string {
    if (salon?.teaserImages?.length) {
      return UrlUtils.getPathToTeaserImage(
        EnvUtils.getBookingDomain(),
        salon.teaserImages[0]
      );
    }

    return '/assets/images/image-placeholder.png';
  }

  public getDiscountProducts(salon: BusinessObject): Product[] {
    return BusinessObjectUtils.getListOfProductsWithAnyDiscountActivated(salon);
  }

  private initSlidesPerView() {
    if (this.breakpointService.isPhoneView()) {
      this.slidePerView = this.generateSlidesPerView(1);
    } else if (this.breakpointService.isTabletView()) {
      this.slidePerView = this.generateSlidesPerView(2);
    } else {
      this.slidePerView = this.generateSlidesPerView(3);
    }
  }

  private generateSlidesPerView(maxSlidesPerView: number): number {
    if (!this.businessObjects?.length) {
      return 1;
    }

    return Math.min(maxSlidesPerView, this.businessObjects.length);
  }
}
